import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuthStore } from './auth-store';

/** Wrap protected route subtrees. Redirects unauthenticated users to /login. */
export function RequireAuth() {
  const token = useAuthStore((s) => s.token);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
